export enum CashbackExecutionPeriod {
  COLLECTION_PERIOD_BASED = "COLLECTION_PERIOD_BASED",
}
